import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components

// Soft UI Dashboard PRO React components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import NewOddsFilter from "views/odds-settings-create";

import { getData } from "Utils/server";
import { getAuthorizationHeader } from "Utils/helpers";

import { useSoftUIController } from "context";

function CreateOddsFilter({ id, data, showModal, signalCloseModal }) {
  const [controller, dispatch] = useSoftUIController();
  const { platform } = controller;
  const [open, setOpen] = useState(false);
  const [initProviders, setInitProviders] = useState([]);
  const [mode, setMode] = useState("create");
  const [initOptions, setInitOptions] = useState(false);
  const [checkChanges, setCheckChanges] = useState(false);

  const handleCancelCreation = (e, update) => {
    e.preventDefault();
    setCheckChanges(true);
  };

  const handleCloseCreation = (e, update) => {
    e.preventDefault();
    if (e.type == "cancel cancel") {
      //setOpen(false);
      //signalCloseModal(false);
      setCheckChanges(false);
    } else {
      setOpen(false);
      signalCloseModal(update);
      if (update) {
        //console.log("calling from update");
        getAvailableTemplates();
      }
      setCheckChanges(false);
    }
  };

  async function initData() {
    //if (!open) return;
    //console.log("Create Odds Filter initData !", mode);
    await getAvailableTemplates();
    if (id != 0 && id != "0") {
      // let apiData = await getApiData(id);
      // setApiData(apiData);
      setMode("edit");
    } else {
      //console.log("calling availableTemplates");
      // await getAvailableTemplates();
      setMode("create");
    }
  }

  async function getApiData(template) {
    let getFiltersEndpoint = `/api/v1/templates/${template}/available-filters`;
    let response = await getData(getFiltersEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
      let myProviders = response.data.providers.map((el) => {
        el.location = el.location ? el.location : "-";
        el.weight = el.weight ? el.weight : "-";
        el.enabled = mode === "edit" ? !el.status : el.status;
        el.selected = mode === "edit" ? !el.status : false;
      });

      return { providers: myProviders, sports: mySports };
    } else {
    }
  }

  function setApiData(apidata) {
    setInitProviders(apidata.providers);
    if (mode === "edit") {
      let initSports = apidata.sports.map((sport) => {
        let el = { ...sport };
        el.selected = false;
        return el;
      });
      setInitSports(initSports);
      let selectedProvider = apidata.providers.find((provider) => {
        if (provider.enabled) return provider;
      });
      setProvider(selectedProvider);
      setActiveStep(1);
    } else {
    }
  }

  async function getAvailableTemplates() {
    if (initOptions) return false;
    if (!platform || platform == "") return false;
    //console.log("getAvailableTemplates proceded");
    setInitOptions(true);
    let getAvailableProvidersEndpoint = `/api/v1/platforms/${platform.value}/master-template`;
    let providers = await getData(getAvailableProvidersEndpoint, {
      Authorization: getAuthorizationHeader(),
    });
    if (providers && providers != null) {
      let providersOptions = [];
      providers.data.providers.forEach((el) => {
        if (!el.oddFilter) {
          if (el.inplay != null && el.pregame != null) {
            providersOptions.push({
              id: el.id,
              name: el.name,
            });
          }
        }
      });

      setInitProviders(providersOptions);
    } else {
    }
  }

  useEffect(() => {
    setOpen(showModal);
    if (showModal) initData();
  }, [showModal]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={(e) => handleCancelCreation(e, false)}
        fullWidth={true}
        maxWidth={"xxl"}
        sx={{ className: "dialog-overflow" }}
      >
        <DialogTitle>{id > 0 ? "Edit Odds Filter" : "Create New Odds Filter"}</DialogTitle>
        <DialogContent style={{ overflow: "visible" }}>
          <NewOddsFilter
            signalCloseModal={handleCloseCreation}
            id={id}
            initData={data}
            providers={initProviders}
            checkChanges={checkChanges}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}

// Setting default values for the props of CreatePlatform
CreateOddsFilter.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreatePlatform
CreateOddsFilter.propTypes = {
  id: PropTypes.number,
  data: PropTypes.object,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
};

export default CreateOddsFilter;
